import React from "react";
import { Row, Col } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import homeimg from "../../assets/images/login.png";
import SolutionForBusinessForm from "../../form/solution_for_business/SolutionForBusinessForm";
import solutionForBusiness from "../../assets/images/relyon_us.png";
const SolutionForBusiness = () => {
  return (
    <div
      test_id="solution_for_business"
      className="solutionForBusinessContainer"
    >
      <Row justify="center" className="solutionForBusinessHero">
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
          className="solutionForBusinessContent"
        >
          <h1 test_id="solution_for_business_title">
            Use our cars to drive <br />
            your business forwards
          </h1>
          <img
            className="solutionForBusinessImg"
            src={solutionForBusiness}
            alt="be different"
          />
          <p>
            Easy lease for business is a complete and cost-effective vehicle
            management solution from procurement to delivery, maintenance,
            replacement and after sales service. It is designed to tailor
            corporate fleet requirements from sales team sedans, executive cars
            through vans. We are confident that we have a perfect fleet solution
            for your business.
          </p>
        </Col>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 6, offset: 3 }}
          xl={{ span: 6, offset: 3 }}
          xxl={{ span: 6, offset: 3 }}
          className="solutionForBusinessForm"
        >
          <SolutionForBusinessForm />
        </Col>
      </Row>
      <Row justify="center" gutter={48} className="whatIsDifferent">
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
        >
          <h2 className="solutionForBusinessContainerTitle">
            What makes our company cars different?
          </h2>
        </Col>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          xxl={{ span: 6 }}
        >
          <h3 className="solutionForBusinessContainerSubtitle">Hassle free</h3>
          <p className="solutionForBusinessContainerDesc">
            Spend less time on car admin and more on your business. Every car
            includes tax, maintenance, servicing and breakdown cover – all for
            one monthly payment.{" "}
          </p>
        </Col>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          xxl={{ span: 6 }}
        >
          <h3 className="solutionForBusinessContainerSubtitle">
            Choose your terms
          </h3>
          <p className="solutionForBusinessContainerDesc">
            Never get stuck with a car you don't need. Set your own terms from
            6-36 months, and choose to swap, stay or cancel afterwards.
          </p>
        </Col>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          xxl={{ span: 6 }}
        >
          <h3 className="solutionForBusinessContainerSubtitle">100% online</h3>
          <p className="solutionForBusinessContainerDesc">
            Nothing to sign, no complex paperwork, no call centres. Manage your
            car, or your fleet at the touch of a button.{" "}
          </p>
        </Col>
      </Row>
      <Row justify="center" gutter={48} className="whatIsEasylease">
        <Col span={24}>
          <h2 className="sectionTitle">Why Yoma Fleet Easy Lease?</h2>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <div>
            <ul>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Costeffective way to drive a brand new car
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                6-36 months flexible contract terms
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Fixed monthly payment
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                No residual risk
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Worry-free maintenance
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Full tyre maintenance
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Affordable way to upgrade the newest models every year
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                International Standard Insurance
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                Full accident management support
              </li>
              <li className="captionText">
                <CheckOutlined className="whyelIcon" />
                24/7 365 help desk
              </li>
            </ul>
          </div>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          xl={{ span: 12 }}
          xxl={{ span: 12 }}
        >
          <div>
            <img className="easyleaseImage" src={homeimg} alt="be different" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SolutionForBusiness;
